import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Key } from 'protractor';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  //readonly rootUrl = "https://localhost:44318";
  readonly rootUrl = environment.baseUrl;
  public roleCalled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }

    //get the data from userObject table
    roleFunctionality() {
      return this.http.get(this.rootUrl + '/api/Role/roleFunctionality');
    }
    saverole(roles)
    {
      debugger;
      return this.http.post(this.rootUrl + '/api/Role/saverole',roles);

    }

    updaterole(roles)
    {
      debugger;
      return this.http.post(this.rootUrl + '/api/Role/UpdateRole',roles);

    }
    updateroleheading(form)
    {
      const data={
        id:form.id,
        name:form.name,
        description:form.description
      }
      return this.http.post(this.rootUrl + '/api/Role/updateroleheading',data);
    }


    getRoleList(form)
    {
      const data={
        company:form
      }
      debugger;
      return this.http.post(this.rootUrl + '/api/Role/getRoleList',data);
    }

    SearchRoleList(searchForm: any) {
      debugger;
      return this.http.post(this.rootUrl + '/api/Role/SearchRoleList', searchForm);
    }

    SearchRespondentData(searchForm: any) {
      return this.http.post(this.rootUrl + '/api/Role/SearchRespondentData', searchForm);
    }

    SearchProjectDetails(searchForm: any) {
      return this.http.post(this.rootUrl + '/api/Role/SearchProjectDetails', searchForm);
    }

    GetCountryLanguageList(searchForm: any) {
      return this.http.post(this.rootUrl + '/api/Role/GetCountryLanguageList', searchForm);
    }


    SearchSubmittedAnswers(searchForm: any) {
      return this.http.post(this.rootUrl + '/api/Role/SearchSubmittedAnswers', searchForm);
    }

    getVendorDetails() {
      return this.http.get(this.rootUrl + '/api/Role/getVendorDetails');
    }

    SearchProjectInfoDetails(projectid) {
      const data={
        projectid:projectid,
      }
      return this.http.post(this.rootUrl + '/api/Role/SearchProjectDetails', data);
    }

    SearchProjectInfo(projectId) {
      const data={
        projectid:projectId,
      }
      return this.http.post(this.rootUrl + '/api/Role/SearchProjectInfo', data);
    }

    exportLinks(params)
    {
        const Data = {
          projectId: params.data.projectId,
          clip: params.data.assignedClip,
        }

        return this.http.post(this.rootUrl + 'api/account/exportLinks', Data);
    }

    GetSurveyLinkData(projectId) {
      const data={
        projectid:projectId,
      }
      return this.http.post(this.rootUrl + '/api/Role/GetSurveyLinkData', data);
    }
    GetSurveyLinkDataForMultiple(projectId) {
      const data={
        projectid:projectId,
      }
      return this.http.post(this.rootUrl + '/api/Role/GetSurveyLinkDataForMultiple', data);
    }
    
    GetVendorDetailsData(projectId) {
      const data={
        projectid:projectId,
      }
      return this.http.post(this.rootUrl + '/api/Role/GetVendorDetailsData', data);
    }


    GetQuestions(projectid,vendID) {
      const data={
        projectid:projectid,
        vendID:vendID,
      }
      return this.http.post(this.rootUrl + '/api/Role/GetQuestions', data);
    }
    GetAllQuestions()
    {
      return this.http.get(this.rootUrl + '/api/Role/GetAllQuestions');
    }


    getViewUserRole(userId)
    {
      debugger;
      const data={
        id:userId
      }
      return this.http.post(this.rootUrl + '/api/Role/getViewUserRole',data);
    }
    getRoleHeading(form)
    {
      const  data={
        id:form
      }
      return this.http.post(this.rootUrl + '/api/Role/getRoleHeading',data);

    }
}

